import {
  Box,
  Flex,
  Grid,
  GridItem,
  Heading,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { useRecoilValue } from "recoil";
import { FaTools } from "react-icons/fa";
import styled from "@emotion/styled";

import ChangeAvailability from "./operatiions/ChangeAvailability";
import TriggerMessage from "./operatiions/TriggerMessage";
import { activeConnectorState } from "atoms/activeConnectorState";
import { loggedInUserState } from "atoms/loggedInUserState";
import { accessLevels } from "utils/accessLevels";

const GlassMorphismBox = styled(Box)`
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
  border: 1px solid rgba(245, 125, 54, 0.25);

  &:hover {
    border-color: rgba(245, 125, 54, 0.4);
  }
`;

const OperationPanel = styled(Box)`
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(8px);
  border-radius: 10px;
  border: 1px solid rgba(245, 125, 54, 0.15);
  padding: 0.75rem;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: rgba(245, 125, 54, 0.3);
  }
`;

const RemoteOperations = ({ refresh, connector: connectorProp }) => {
  const activeConnectorFromState = useRecoilValue(activeConnectorState);
  const activeConnector = connectorProp ?? activeConnectorFromState;
  const loggedInUser = useRecoilValue(loggedInUserState);
  const role = loggedInUser?.role;
  const canEdit = accessLevels[role]?.accessLevel <= 2;

  const status = activeConnector?.Status || "Unavailable";
  const isUnavailable = status === "Unavailable";

  const labelColor = useColorModeValue("gray.700", "gray.200");

  return (
    <GlassMorphismBox
      w="100%"
      h="100%"
      maxW="100%"
      minW={0}
      borderRadius={12}
      pt={2.5}
      px={{ base: 2, md: 2.5 }}
      pb={{ base: 2.5, md: 3 }}
      position="relative"
      overflow="hidden"
    >
      <Flex align="center" justify="center" mb={2.5}>
        <Icon as={FaTools} mr={1.5} color="#f57d36" boxSize={3.5} />
        <Heading size="sm" fontWeight={600} color={labelColor} fontSize="sm">
          Remote Operations
        </Heading>
      </Flex>

      <Grid
        templateColumns={{ base: "1fr", sm: "1fr 1fr" }}
        gap={{ base: 2, md: 3 }}
        alignItems="start"
      >
        {/* Change Availability — always available */}
        <GridItem>
          <OperationPanel opacity={canEdit ? 1 : 0.5} pointerEvents={canEdit ? "auto" : "none"}>
            <ChangeAvailability refresh={refresh} connector={connectorProp} inline />
          </OperationPanel>
        </GridItem>

        {/* Trigger Message — always available */}
        <GridItem>
          <OperationPanel opacity={canEdit ? 1 : 0.5} pointerEvents={canEdit ? "auto" : "none"}>
            <TriggerMessage refresh={refresh} connector={connectorProp} inline />
          </OperationPanel>
        </GridItem>
      </Grid>
    </GlassMorphismBox>
  );
};

export default RemoteOperations;
